// extracted by mini-css-extract-plugin
export default {"recos":"g7-z","productCardOverride":"h7-z","rowHasBadge":"i7-z"};